import { ChainId } from '@pulsex/chains'
import { Address, getContract, PublicClient } from 'viem'

import { iMulticallABI } from './abis/IMulticall'
import { MULTICALL_ADDRESS, MULTICALL3_ADDRESSES, MULTICALL3_ADDRESS } from './constants/contracts'

type Params = {
  chainId: ChainId
  client?: PublicClient
}

export function getMulticallContract({ chainId, client }: Params) {
  const address = MULTICALL_ADDRESS[chainId]
  if (!address) {
    throw new Error(`Multicall not supported on chain ${chainId}`)
  }

  return getContract({ abi: iMulticallABI, address, client: client as PublicClient })
}

export function getMulticall3ContractAddress(chainId?: ChainId): Address {
  return MULTICALL3_ADDRESSES[chainId || ChainId.PULSECHAIN] || MULTICALL3_ADDRESS
}
